import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const sampleProjectBoardEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "async-sample-project-board-nudge-entrypoint" */ './index.tsx'),
	),
	getPreloadProps: () => ({}),
});
